import { CARRIER_DATA_INITIAL_VALUES, CarrierData } from "./CarrierData";
import { ROLLSET_DATA_INITIAL_VALUES, RollsetData } from "./RollsetData";

export interface CarrierRollsetData extends CarrierData, RollsetData {}

export const CARRIER_ROLLSET_DATA_INITIAL_VALUES: CarrierRollsetData = {
	...CARRIER_DATA_INITIAL_VALUES,
	...ROLLSET_DATA_INITIAL_VALUES,
};
